import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
  CustomInput,
} from "reactstrap";
import noperson from "../../assets/img/addlogo.png";
import axios from "axios";
import {
  INSERT_CLIENT_CHANNELS,
  UPDATE_CHANNELS,
  CHANNELS_BY_ID,
  CLIENT_API,
  ALL_CLIENT_LIST,
  BASE_URL_CHAT_WHATSAPP


} from "../../../src/constants";
import { useHistory } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";

let smsType = [

  { value: "T", label: "Text" },
  { value: "U", label: "Unicode" },
];
let selectType = [
  {
    value: "",
    label: "Select User Type",
    isDisabled: true,
  },
  { value: 1, label: "Prepaid" },
  { value: 2, label: "Postpaid" },
];
let category = [
  {
    value: "",
    label: "Select Category",
    isDisabled: true,
  },
  { value: 1, label: "Marketing" },
  { value: 2, label: "Utility" },
  { value: 3, label: "Authentication" },
  { value: 4, label: "Service" },

];
let clientsList = [];
let systemIdList = [];

const CreateChannel = (props) => {
  let rcsInitial = {
    rcstemplate: "",
    rcsctgry: "",
    rcsname: "",
    rcscontent: "",
    rcssenderArr: [
      {
        rcssenderId: "",
      },
    ],
  };

  let emailInitial = {
    emailtemplate: "",
    emailctgry: "",
    emailname: "",
    emailcontent: "",
    emailsenderArr: [
      {
        emailsenderId: "",
      },
    ],
  };
  let smsInitial = {
    smstemplate: "",
    smsctgry: "",
    smsname: "",
    smstype: "",
    smscontent: "",
    smssenderArr: [
      {
        smssenderId: "",
      },
    ],
  };
  let ivrInitial = {
    ivrtemplate: "",
    ivrctgry: "",
    ivrname: "",
    ivrcontent: "",
    ivrsenderArr: [
      {
        ivrsenderId: "",
      },
    ],
  };
  let whatsappInitial = {
    whatsapptemplate: "",
    whatsappctgry: "",
    whatsappname: "",
    whatsappcontent: "",
    whatsappsenderArr: [
      {
        whatsappsenderId: "",
      },
    ],

  };
  let initialValues = {
    clientName: "",
    peid: "",
    systemId: "",
    clientId: "",
    emailChkd: 0,
    ivrChkd: 0,
    rcsChkd: 0,
    smsChkd: 0,
    whatsppChkd: 0,
    emailSid: "",
    ivrSid: "",
    rcsSid: "",
    smsSid: "",
    whatsppSid: "",
    noofusers: 0,
    isActive: false,
    emailTemp: [emailInitial],
    rcsTemp: [rcsInitial],
    whatsappTemp: [whatsappInitial],
    ivrTemp: [ivrInitial],
    smsTemp: [smsInitial],
    whatsappnmspce: "",
    whatsapptoken: "",
  };
  const [channel, setChannel] = useState(initialValues);
  const [isLoading, setIsLoading] = useState(true);
  const inputFile = useRef(null);
  const notificationAlertRef = useRef(null);
  const navigate = useHistory();
  const [error, setError] = useState()
  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  useEffect(() => {
    props?.location?.state?.id ? fetchChannel() : user?.client != 0 ? fetchClientbyid(user?.client) : getClients();

  }, []);

  const fetchClientbyid = async (id) => {


    setIsLoading(true)
    clientsList = [];
    systemIdList = [];

    if (id) {
      axios
        .post(CLIENT_API, { id: id })
        .then((res) => {
          setIsLoading(false)
          let clientObj = res?.data[0];
          const system_idArr = clientObj?.system_id?.split(",")
          system_idArr?.map(item => {
            systemIdList.push({ label: item, value: item })
          })
          setChannel({
            ...channel, peid: res?.data[0]?.peid, systemId: res?.data[0]?.system_id

          })
          clientsList.push({ value: clientObj.id, label: clientObj.company_name })

        })
        .catch((e) => {
          console.log(e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        }).finally(()=>{
          setIsLoading(false)
        })
    }

  };

  const getClients = async () => {
    setIsLoading(true)
    clientsList = [];
    await axios.get(`${ALL_CLIENT_LIST}?client_id=${user?.client}`).then(res => {
      setIsLoading(false)
      res?.data?.data?.map(item => clientsList.push({ value: item.id, label: item.company_name }))
    }).catch(err => {
      let options = {};
      options = {
        place: "tr",
        message: "Unable fetch record",
        type: "warning",
        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
    })
  }
  const fetchChannel = () => {
    clientsList = []
    if (props?.location?.state?.id) {
      setIsLoading(true)
      let id = props?.location?.state?.id;

      axios
        .get(CHANNELS_BY_ID + '?id=' + id)
        .then((res) => {
          setIsLoading(false)
          let clientObj = res?.data[0];
          clientsList.push({ value: clientObj.client_id, label: clientObj.company_name })
          if (clientObj?.channels_type == "sms") {
            const senderids = clientObj.senderid.split(",");
            let senderArr = []
            for (let i = 0; i < senderids.length; i++) {
              senderArr.push({ smssenderId: senderids[i] })
            }
            const catgry = category?.filter(item => item.value == clientObj?.category)

            const tempObj = {
              smstemplate: clientObj.template,
              smsname: clientObj?.name,

              smstype: clientObj?.sms_type == "U" ? { label: "Unicode", value: "U" } : { label: "Text", value: "T" },
              smscontent: clientObj?.content,
              smsctgry: catgry,
              smssenderArr: senderArr
            }
            setChannel(preClient => ({
              ...preClient, peid: clientObj.peid, systemId: { label: clientObj?.system_id, value: clientObj?.system_id }, smsTemp: [tempObj], clientName: { value: clientObj.client_id, label: clientObj.company_name }, smsChkd: 1
            }))
          }
          if (clientObj?.channels_type == "email") {
            const senderids = clientObj.senderid.split(",");
            let senderArr = []
            for (let i = 0; i < senderids.length; i++) {
              senderArr.push({ emailsenderId: senderids[i] })
            }
            const catgry = category?.filter(item => item.value === clientObj?.category)
            const tempObj = {
              emailtemplate: clientObj.template,
              emailcontent: clientObj.content,
              emailctgry: catgry,
              emailsenderArr: senderArr
            }
            setChannel(preClient => ({
              ...preClient, emailTemp: [tempObj], clientName: { value: clientObj.client_id, label: clientObj.company_name }, emailChkd: 1
            }))
          }
          if (clientObj?.channels_type == "rcs") {
            const senderids = clientObj.senderid.split(",");
            let senderArr = []
            for (let i = 0; i < senderids.length; i++) {
              senderArr.push({ rcssenderId: senderids[i] })
            }
            const catgry = category?.filter(item => item.value === clientObj?.category)
            const tempObj = {
              rcstemplate: clientObj.template,
              rcscontent: clientObj.content,
              rcsname: clientObj?.sms_type,
              rcsctgry: catgry,
              rcssenderArr: senderArr
            }
            setChannel(preClient => ({
              ...preClient, rcsTemp: [tempObj], clientName: { value: clientObj.client_id, label: clientObj.company_name }, rcsChkd: 1
            }))
          }
          if (clientObj?.channels_type == "ivr") {
            const senderids = clientObj.senderid.split(",");
            let senderArr = []
            for (let i = 0; i < senderids.length; i++) {
              senderArr.push({ ivrsenderId: senderids[i] })
            }
            const catgry = category?.filter(item => item.value === clientObj?.category)
            const tempObj = {
              ivrtemplate: clientObj.template,
              ivrcontent: clientObj.content,
              ivrctgry: catgry,
              ivrsenderArr: senderArr
            }
            setChannel(preClient => ({
              ...preClient, ivrTemp: [tempObj], clientName: { value: clientObj.client_id, label: clientObj.company_name }, ivrChkd: 1
            }))
          }
          if (clientObj?.channels_type == "whatsapp") {
            const senderids = clientObj.senderid.split(",");
            let senderArr = []
            for (let i = 0; i < senderids.length; i++) {
              senderArr.push({ whatsappsenderId: senderids[i] })
            }

            const catgry = category?.filter(item => item.value === clientObj?.category)

            const tempObj = {
              whatsapptemplate: clientObj.template,
              whatsappcontent: clientObj.content,
              whatsappctgry: catgry,
              whatsappsenderArr: senderArr
            }
            setChannel(preClient => ({
              ...preClient, whatsappTemp: [tempObj], clientName: { value: clientObj.client_id, label: clientObj.company_name }, whatsppChkd: 1, whatsappnmspce: clientObj.namespace,
              whatsapptoken: clientObj.token,
            }))
          }



        })
        .catch((e) => console.log(e));
    }
  };

  const validate = () => {

    let error = {}
    if (!channel?.clientName?.value) {
      error.clientName = "Please Select Client"
    }
    if (channel?.emailChkd === 0 && channel?.smsChkd === 0 && channel?.whatsppChkd === 0 && channel?.ivrChkd === 0 && channel?.rcsChkd === 0) {
      error.channel = "Please Select Atlease One Channel"
    } else if (channel?.emailChkd !== 0 && (channel?.emailTemp[0]?.emailtemplate == "" || channel.emailTemp[0].emailcontent == "" || channel?.emailTemp[0]?.emailsenderArr[0].emailsenderId == "")) {
      error.emailtemplate = "Please Add Email Templeate"

    } else if (channel?.smsChkd !== 0 && (channel?.smsTemp[0]?.smstemplate == "" || channel?.smsTemp[0]?.smsname == "" || channel?.smsTemp[0]?.smstype == "" || channel?.smsTemp[0]?.smscontent == "" || channel?.smsTemp[0]?.smssenderArr[0]?.smssenderId == "")) {
      error.smstemplate = "Please Add SMS Templeate"

    }

    else if (channel?.whatsppChkd !== 0 && (channel.whatsappTemp[0].whatsapptemplate == "" || channel.whatsappTemp[0].whatsappcontent == "" || channel.whatsappTemp[0].whatsappnmspce == "" || channel.whatsappTemp[0].whatsapptoken == "" || channel?.whatsappTemp[0]?.whatsappsenderArr[0].whatsappsenderId == "")) {
      error.whatsapptemplate = "Please Add Whatsapp Templeate"

    } else if (channel?.rcsChkd !== 0 && (channel.rcsTemp[0].rcstemplate == "" || channel?.rcsTemp[0]?.rcsname == "" || channel.rcsTemp[0].rcscontent == "" || channel?.rcsTemp[0]?.rcssenderArr[0].rcssenderId == "")) {
      error.rcstemplate = "Please Add RCS Templeate"

    } else if (channel?.ivrChkd !== 0 && (channel.ivrTemp[0].ivrtemplate == "" ||  channel?.ivrTemp[0]?.ivrsenderArr[0].ivrsenderId == "")) {
      error.ivrtemplate = "Please Add IVR Templeate"

    }



    return error;

  }

  const submitChannel = async () => {
    console.log(channel);
    const isvalid = validate();


    setError(isvalid);
    if (Object.keys(isvalid).length == 0) {
      let payload = {
        clientId: channel?.clientName?.value,
        peid: channel.peid,
        whatsappnmspce: channel.whatsappnmspce,
        whatsapptoken: channel.whatsapptoken,
        systemId: channel?.systemId?.value,
        smsChkd: channel.smsChkd,
        smsTemp: channel.smsTemp,
        emailChkd: channel.emailChkd,
        emailTemp: channel.emailTemp,
        ivrChkd: channel.ivrChkd,
        ivrTemp: channel.ivrTemp,
        whatsppChkd: channel.whatsppChkd,
        whatsappTemp: channel.whatsappTemp,
        rcsChkd: channel.rcsChkd,
        rcsTemp: channel.rcsTemp,
      }
      if (props?.location?.state?.id) {
        const reqbody = { ...payload, id: props?.location?.state?.id };
        setIsLoading(true)
        await axios
          .post(UPDATE_CHANNELS, reqbody)
          .then((data) => {
            setIsLoading(false)
            let options = {};
            options = {
              place: "tr",
              message: "Updated Successfully",
              type: "success",
              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);
            setTimeout(() => {
              navigate.goBack();
            }, 1000)
          })
          .catch((err) => console.log(err));
      } else {
        setIsLoading(true)
        await axios
          .post(INSERT_CLIENT_CHANNELS, payload)
          .then((data) => {
            setIsLoading(false)
            let options = {};
            options = {
              place: "tr",
              message: "Saved Successfully",
              type: "success",
              autoDismiss: 2,
            };
            notificationAlertRef.current.notificationAlert(options);
            setTimeout(() => {
              navigate.goBack();
            }, 1000)

          })
          .catch((err) => console.log(err));
      }
    }
  };


  const addTemplateRow = (name) => {

    switch (name) {
      case 'email':
        const emailObj = channel.emailTemp[channel.emailTemp.length - 1]
        const emaillngth = channel?.emailTemp[channel.emailTemp.length - 1]?.emailsenderArr.length - 1;
        emailObj?.emailtemplate && emailObj?.emailcontent && emailObj?.emailsenderArr[emaillngth]?.emailsenderId && channel.emailTemp.push(emailInitial);
        // channel.emailTemp.push(emailInitial);
        setChannel({ ...channel });
        break;

      case 'rcs':
        //channel.rcsTemp.push(rcsInitial);
        const rcsObj = channel.rcsTemp[channel.rcsTemp.length - 1]

        const rcslngth = channel?.rcsTemp[channel.rcsTemp.length - 1]?.rcssenderArr.length - 1;
        rcsObj?.rcstemplate && rcsObj?.rcsname && rcsObj?.rcscontent && rcsObj?.rcssenderArr[rcslngth]?.rcssenderId && channel?.rcsTemp.push(rcsInitial);
        setChannel({ ...channel });
        break;
      case 'ivr':
        const ivrObj = channel.ivrTemp[channel.ivrTemp.length - 1]
        const ivrlngth = channel?.ivrTemp[channel.ivrTemp.length - 1]?.ivrsenderArr.length - 1;
        ivrObj?.ivrtemplate && ivrObj?.ivrcontent && ivrObj.ivrsenderArr[ivrlngth].ivrsenderId && channel.ivrTemp.push(ivrInitial);
        // channel.ivrTemp.push(ivrInitial);
        setChannel({ ...channel });
        break;
      case 'whatsapp':
        const whatsappObj = channel.whatsappTemp[channel.whatsappTemp.length - 1]
        const arrylngth = channel?.whatsappTemp[channel.whatsappTemp.length - 1]?.whatsappsenderArr.length - 1;
        // channel?.emailTemp[index].emailsenderArr[arrylngth].emailsenderId
        whatsappObj?.whatsapptemplate && whatsappObj?.whatsappcontent && whatsappObj.whatsappsenderArr[arrylngth].whatsappsenderId && channel.whatsappTemp.push(whatsappInitial);
        setChannel({ ...channel });


        break;
      case 'sms':
        // channel.smsTemp.push(smsInitial);
        const smsObj = channel.smsTemp[channel.smsTemp.length - 1]
        const smslngth = channel?.smsTemp[channel.smsTemp.length - 1]?.smssenderArr.length - 1;
        smsObj.smstemplate && smsObj.smsname && smsObj.smstype && smsObj.smscontent && smsObj.smssenderArr[smslngth].smssenderId && channel.smsTemp.push(smsInitial);
        setChannel({ ...channel });
        break;
    }

  };

  const removeTemplateRow = (name, index) => {

    switch (name) {
      case 'email':
        let emailobj = channel.emailTemp.filter((name, i) => i != index);
        setChannel({ ...channel, emailTemp: emailobj });
        break;
      case 'rcs':
        let rcsobj = channel.rcsTemp.filter((name, i) => i != index);
        setChannel({ ...channel, rcsTemp: rcsobj });
        break;
      case 'ivr':
        let ivrobj = channel.ivrTemp.filter((name, i) => i != index);
        setChannel({ ...channel, ivrTemp: ivrobj });
        break;
      case 'whatsapp':
        let whatsappobj = channel.whatsappTemp.filter((name, i) => i != index);
        setChannel({ ...channel, whatsappTemp: whatsappobj });
        break;
      case 'sms':
        let smsobj = channel.smsTemp.filter((name, i) => i != index);
        setChannel({ ...channel, smsTemp: smsobj });
        break;
    }

  };

  const addSenderIdRow = (name, index, i) => {

    if (name == "email") {

      //  const whatsappObj = channel.whatsappTemp[channel.whatsappTemp.length-1]
      // whatsappObj.whatsapptemplate&&channel.whatsappTemp.push(whatsappInitial);

      const arrylngth = channel?.emailTemp[index]?.emailsenderArr.length - 1;
      if (channel?.emailTemp[index].emailsenderArr[arrylngth].emailsenderId) {
        channel?.emailTemp[index].emailsenderArr?.map((item, j) => {


          if (j == i) {
            let newArr = {
              emailsenderId: "",
            };
            channel?.emailTemp[index].emailsenderArr.push(newArr);
          }
        });
        setChannel({ ...channel });
      }
    }
    if (name == "rcs") {
      const arrylngth = channel?.rcsTemp[index]?.rcssenderArr.length - 1;
      if (channel?.rcsTemp[index].rcssenderArr[arrylngth].rcssenderId) {
        channel?.rcsTemp[index].rcssenderArr?.map((item, j) => {

          if (j == i) {
            let newArr = {
              rcssenderId: "",
            };
            channel?.rcsTemp[index].rcssenderArr.push(newArr);
          }

        });

        setChannel({ ...channel });
      }
    }
    if (name == "whatsapp") {
      const arrylngth = channel?.whatsappTemp[index]?.whatsappsenderArr.length - 1;
      if (channel?.whatsappTemp[index].whatsappsenderArr[arrylngth].whatsappsenderId) {
        channel?.whatsappTemp[index].whatsappsenderArr?.map((item, j) => {
          if (j == i) {
            let newArr = {
              whatsappsenderId: "",
            };
            channel?.whatsappTemp[index].whatsappsenderArr.push(newArr);
          }

        });

        setChannel({ ...channel });
      }
    }
    if (name == "ivr") {
      const arrylngth = channel?.ivrTemp[index]?.ivrsenderArr.length - 1;
      if (channel?.ivrTemp[index].ivrsenderArr[arrylngth].ivrsenderId) {
        channel?.ivrTemp[index].ivrsenderArr?.map((item, j) => {
          if (j == i) {
            let newArr = {
              ivrsenderId: "",
            };
            channel?.ivrTemp[index].ivrsenderArr.push(newArr);
          }

        });

        setChannel({ ...channel });
      }
    }
    if (name == "sms") {
      const arrylngth = channel?.smsTemp[index]?.smssenderArr.length - 1;
      if (channel?.smsTemp[index].smssenderArr[arrylngth].smssenderId) {
        channel?.smsTemp[index].smssenderArr?.map((item, j) => {
          if (j == i) {
            let newArr = {
              smssenderId: "",
            };
            channel?.smsTemp[index].smssenderArr.push(newArr);
          }

        });

        setChannel({ ...channel });
      }
    }

  };

  const removeSenderIdRow = (name, index, i) => {
    if (name == "email") {
      let subchildObjArr = channel.emailTemp;
      let subchildObj = channel?.emailTemp[index].emailsenderArr?.filter(
        (item, j) => j != i
      );
      subchildObjArr[index].emailsenderArr = subchildObj;
      setChannel({ ...channel, emailTemp: subchildObjArr });
    }
    else if (name == "whatsapp") {
      let subchildObjArr = channel.whatsappTemp;
      let subchildObj = channel?.whatsappTemp[index].whatsappsenderArr?.filter(
        (item, j) => j != i
      );
      subchildObjArr[index].whatsappsenderArr = subchildObj;
      setChannel({ ...channel, whatsappTemp: subchildObjArr });
    }
    else if (name == "rcs") {
      let subchildObjArr = channel.rcsTemp;
      let subchildObj = channel?.rcsTemp[index].rcssenderArr?.filter(
        (item, j) => j != i
      );
      subchildObjArr[index].rcssenderArr = subchildObj;
      setChannel({ ...channel, rcsTemp: subchildObjArr });
    }
    else if (name == "ivr") {
      let subchildObjArr = channel.ivrTemp;
      let subchildObj = channel?.ivrTemp[index].ivrsenderArr?.filter(
        (item, j) => j != i
      );
      subchildObjArr[index].ivrsenderArr = subchildObj;
      setChannel({ ...channel, ivrTemp: subchildObjArr });
    }
    else if (name == "sms") {
      let subchildObjArr = channel.smsTemp;
      let subchildObj = channel?.smsTemp[index].smssenderArr?.filter(
        (item, j) => j != i
      );
      subchildObjArr[index].smssenderArr = subchildObj;
      setChannel({ ...channel, smsTemp: subchildObjArr });
    }
  };

  const templateHandle = (val, type, index) => {
    const { name, value } = val.target;
    if (type === "email") {
      let emailObj = channel.emailTemp.map((item, i) => {
        if (i == index) {
          return { ...item, [name]: value };
        }
        return item;
      });
      setChannel({ ...channel, emailTemp: emailObj });
    }
    else if (type === "rcs") {
      let rcsObj = channel.rcsTemp.map((item, i) => {
        if (i == index) {
          return { ...item, [name]: value };
        }
        return item;
      });
      setChannel({ ...channel, rcsTemp: rcsObj });
    }
    else if (type === "whatsapp") {
      let whatsappObj = channel.whatsappTemp.map((item, i) => {
        if (i == index) {
          return { ...item, [name]: value };
        }
        return item;
      });
      setChannel({ ...channel, whatsappTemp: whatsappObj });
    }
    else if (type === "sms") {
      let smsObj = channel.smsTemp.map((item, i) => {
        if (i == index) {
          return { ...item, [name]: value };
        }
        return item;
      });
      setChannel({ ...channel, smsTemp: smsObj });
    }
    else if (type === "ivr") {
      let ivrObj = channel.ivrTemp.map((item, i) => {
        if (i == index) {
          return { ...item, [name]: value };
        }
        return item;
      });
      setChannel({ ...channel, ivrTemp: ivrObj });
    }
  };

  const senderHandle = (event, i, j, type) => {
    const { name, value } = event.target;
    if (type === "email") {
      let new_document = [...channel.emailTemp];
      channel?.emailTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].emailsenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, emailTemp: new_document });
    }
    else if (type === "rcs") {
      let new_document = [...channel.rcsTemp];
      channel?.rcsTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].rcssenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, rcsTemp: new_document });
    }
    else if (type === "whatsapp") {
      let new_document = [...channel.whatsappTemp];
      channel?.whatsappTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].whatsappsenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, whatsappTemp: new_document });
    }
    else if (type === "rcs") {
      let new_document = [...channel.ivrTemp];
      channel?.ivrTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].ivrsenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, ivrTemp: new_document });
    }
    else if (type === "sms") {
      let new_document = [...channel.smsTemp];
      channel?.smsTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].smssenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, smsTemp: new_document });
    } else if (type === "ivr") {
      let new_document = [...channel.ivrTemp];
      channel?.ivrTemp?.map((item, index) => {
        if (i == index) {
          return (new_document[i].ivrsenderArr[j][name] = value);
        }
        return item;
      });
      setChannel({ ...channel, ivrTemp: new_document });
    }
  };

  const uploadImg = (file, index) => {

    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {


        let imgUrl = { target: { name: "ivrcontent", value: response?.data?.Response } };
        templateHandle(imgUrl, "ivr", index)
      })
      .catch((err) => console.log("err==>", err));
  };

  return (
    <>

      <div className="content pd-0">
        <Row>
          <Card>
            <CardBody className="mb-0">
              <NotificationAlert ref={notificationAlertRef} />
              <LoadingScreen
                children=""
                loading={isLoading}
                bgColor="rgba(0,0,0,0.7)"
                spinnerColor="#9ee5f8"
                textColor="#676767"
                logoSrc={logo}
                text="Loading..."
              ></LoadingScreen>
              <Row>
                <Col sm="10">
                  <h4 className="mt-4">
                    <Button
                      className="btn btn-icon btn-round btn-success"
                      onClick={() => navigate.goBack()}
                    >
                      <i class="tim-icons icon-minimal-left"></i>
                    </Button>
                    {props?.location?.state?.id ? "Update Template" : "Create Template"}
                  </h4>
                </Col>
              </Row>
              <Row>
                <Label>Client</Label>
                <Col sm="4" className="mb-4">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    name="Select Channel"
                    value={channel.clientName}
                    onChange={(value) => {
                      setChannel(prev => ({ ...prev, clientName: value }));
                    }}
                    options={clientsList}
                  />
                  {error?.clientName && <span style={{ color: "red" }}>{error.clientName}</span>}
                </Col>
              </Row>
              <Row>
                <Col md="10" sm="8">
                  {error?.channel && <span style={{ color: "red" }}>{error.channel}</span>}
                  <Row className="mb-2 mt-5">
                    <Col sm="2" className="mb-2">
                      <h3>Channels</h3>

                    </Col>
                    <Col sm="1" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={channel.smsChkd == 1 ? true : false}
                            readOnly={true}
                            //readOnly={props?.location?.state?.id&&channel.smsChkd==1?false:true}
                            value={channel.smsChkd}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setChannel({ ...channel, smsChkd: 1 })
                                : setChannel({ ...channel, smsChkd: 0 });
                            }}
                          />
                          <span className="form-check-sign" />
                          SMS
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col sm="2" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={channel.whatsppChkd == 1 ? true : false}
                            readOnly={props?.location?.state?.id && channel.whatsppChkd == 1 ? false : true}
                            value={channel.whatsppChkd}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setChannel({ ...channel, whatsppChkd: 1 })
                                : setChannel({ ...channel, whatsppChkd: 0 });
                            }}
                          />
                          <span className="form-check-sign" />
                          Whatsapp
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col sm="1" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={channel.rcsChkd == 1 ? true : false}
                            value={channel.rcsChkd}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setChannel({ ...channel, rcsChkd: 1 })
                                : setChannel({ ...channel, rcsChkd: 0 });
                            }}
                          />
                          <span className="form-check-sign" />
                          RCS
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col sm="1" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={channel.emailChkd == 1 ? true : false}
                            value={channel.emailChkd}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setChannel({ ...channel, emailChkd: 1 })
                                : setChannel({ ...channel, emailChkd: 0 });
                            }}
                          />
                          <span className="form-check-sign" />
                          Email
                        </Label>
                      </FormGroup>
                    </Col>


                    <Col sm="1" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={channel.ivrChkd == 1 ? true : false}
                            value={channel.ivrChkd}
                            onClick={(e) => {
                              e.target.checked === true
                                ? setChannel({ ...channel, ivrChkd: 1 })
                                : setChannel({ ...channel, ivrChkd: 0 });
                            }}
                          />
                          <span className="form-check-sign" />
                          Ivr
                        </Label>
                      </FormGroup>
                    </Col>


                  </Row>
                  {/* SMS MENU */}
                  {channel.smsChkd === 1 && (
                    <Row
                      style={{
                        borderBottom: "1px dotted black",
                        margin: "15px",
                        padding: "15px",
                      }}
                    >
                      {error?.smstemplate && <span style={{ color: "red" }}>{error?.smstemplate}</span>}
                      <Col sm="1" className="mb-2 ">
                        <Label>SMS</Label>
                      </Col>
                      <Col sm="3" className="mb-2">

                        <FormGroup>
                          <Input
                            type="text"
                            name="peid"
                            readOnly={true}
                            value={channel.peid}
                            onChange={(e) =>
                              setChannel({ ...channel, peid: e.target.value })
                            }
                            placeholder="PE ID"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="Select Channel"

                          value={channel.systemId}
                          onChange={(value) => {
                            setChannel({ ...channel, systemId: value })
                          }}
                          options={systemIdList}
                          placeholder="System Id"
                        />
                      </Col>
                      {/* <Col sm="4" className="mb-2">
                      <FormGroup>
                        <Input
                          type="text"
                          name="systemId"
                          value={channel.systemId}
                          onChange={(e) =>
                            setChannel({ ...channel, systemId: e.target.value })
                          }
                          placeholder="System id, Sytem id"
                        />
                      </FormGroup>
                    </Col> */}

                      {channel?.smsTemp?.map((smsitem, index) => {
                        return (
                          <>
                            <Row
                              style={{
                                background: "rgb(243, 243, 243)",
                                margin: "5px",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Id"
                                    name="smstemplate"
                                    type="number"
                                    value={smsitem.smstemplate}
                                    onChange={(e) =>
                                      templateHandle(e, "sms", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Name"
                                    name="smsname"
                                    type="text"
                                    value={smsitem.smsname}
                                    onChange={(e) =>
                                      templateHandle(e, "sms", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="smsctgry"

                                  value={smsitem?.smsctgry}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "smsctgry",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "sms", index)
                                  }}
                                  options={category}
                                  placeholder="Select Calegory"
                                />
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="smstype"

                                  value={smsitem?.smstype}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "smstype",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "sms", index)
                                  }}
                                  options={smsType}
                                  placeholder="Select Type"
                                />
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Message Text"
                                    name="smscontent"
                                    type="textarea"
                                    maxLength={5000}
                                    value={smsitem.smscontent}
                                    onChange={(e) =>
                                      templateHandle(e, "sms", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              {smsitem?.smssenderArr?.map((senderitem, si) => {
                                return (
                                  <>
                                    <Col sm="3" className="mb-2 ">
                                      <FormGroup>
                                        <Input
                                          placeholder="Sender Id"
                                          type="text"
                                          name="smssenderId"
                                          value={senderitem.smssenderId}
                                          onChange={(e) =>
                                            senderHandle(e, index, si, "sms")
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    {si == 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            addSenderIdRow("sms", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-add"></i>
                                        </Button>
                                      </Col>
                                    )}
                                    {si > 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            removeSenderIdRow("sms", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-delete"></i>
                                        </Button>
                                      </Col>
                                    )}
                                  </>
                                );
                              })}

                              {index == 0 ? (
                                <Col md="2" sm="12">
                                  {
                                    !props?.location?.state?.id &&
                                    <Button
                                      className="btn btn-icon btn-round btn-success"
                                      onClick={() => { addTemplateRow("sms") }}
                                    >
                                      <i class="tim-icons icon-simple-add"></i>
                                    </Button>
                                  }
                                </Col>
                              ) : (
                                <Col md="2" sm="12">
                                  <Button
                                    className="btn btn-icon btn-round btn-danger "
                                    onClick={() =>
                                      removeTemplateRow("sms", index)
                                    }
                                  >
                                    <i class="tim-icons icon-simple-delete"></i>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </>
                        );
                      })}

                    </Row>
                  )}
                  {channel.whatsppChkd === 1 && (
                    <Row
                      style={{
                        borderBottom: "1px dotted black",
                        margin: "15px",
                        padding: "15px",
                      }}
                    >{error?.whatsapptemplate && <span style={{ color: "red" }}>{error?.whatsapptemplate}</span>}
                      <Col sm="2" className="mb-2 ">
                        <Label>whatsapp</Label>
                      </Col>
                      <Col sm="3" className="mb-2 ">
                        <FormGroup>
                          <Input
                            placeholder="Type here name space"
                            name="whatsappnmspce"
                            type="textarea"
                            maxLength={5000}
                            value={channel?.whatsappnmspce}
                            onChange={(e) =>
                              setChannel({ ...channel, whatsappnmspce: e?.target?.value })
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="3" className="mb-2 ">
                        <FormGroup>
                          <Input
                            placeholder="Type here token"
                            name="whatsapptoken"
                            type="textarea"
                            maxLength={5000}
                            value={channel?.whatsapptoken}
                            onChange={(e) =>
                              setChannel({ ...channel, whatsapptoken: e?.target?.value })
                            }
                          />
                        </FormGroup>
                      </Col>



                      {channel?.whatsappTemp?.map((whatsappitem, index) => {
                        return (
                          <>
                            <Row
                              style={{
                                background: "rgb(243, 243, 243)",
                                margin: "5px",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Id"
                                    name="whatsapptemplate"
                                    type="text"
                                    value={whatsappitem.whatsapptemplate}
                                    onChange={(e) =>
                                      templateHandle(e, "whatsapp", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Type here"
                                    name="whatsappcontent"
                                    type="textarea"
                                    maxLength={5000}
                                    value={whatsappitem.whatsappcontent}
                                    onChange={(e) =>
                                      templateHandle(e, "whatsapp", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="whatsappctgry"

                                  value={whatsappitem?.whatsappctgry}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "whatsappctgry",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "whatsapp", index)
                                  }}
                                  options={category}
                                  placeholder="Select Calegory"
                                />
                              </Col>



                              {whatsappitem?.whatsappsenderArr?.map((senderitem, si) => {
                                return (
                                  <>
                                    <Col sm="3" className="mb-2 ">
                                      <FormGroup>
                                        <Input
                                          placeholder="Sender Id"
                                          type="text"
                                          name="whatsappsenderId"
                                          value={senderitem.whatsappsenderId}
                                          onChange={(e) =>
                                            senderHandle(e, index, si, "whatsapp")
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    {si == 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            addSenderIdRow("whatsapp", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-add"></i>
                                        </Button>
                                      </Col>
                                    )}
                                    {si > 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            removeSenderIdRow("whatsapp", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-delete"></i>
                                        </Button>
                                      </Col>
                                    )}
                                  </>
                                );
                              })}

                              {index == 0 ? (
                                <Col md="2" sm="12">
                                  {
                                    !props?.location?.state?.id && <Button
                                      className="btn btn-icon btn-round btn-success"
                                      onClick={() => { addTemplateRow("whatsapp") }}
                                    >
                                      <i class="tim-icons icon-simple-add"></i>
                                    </Button>
                                  }

                                </Col>
                              ) : (
                                <Col md="2" sm="12">
                                  <Button
                                    className="btn btn-icon btn-round btn-danger "
                                    onClick={() =>
                                      removeTemplateRow("whatsapp", index)
                                    }
                                  >
                                    <i class="tim-icons icon-simple-delete"></i>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </>
                        );
                      })}

                    </Row>
                  )}


                  {channel.rcsChkd === 1 && (
                    <Row
                      style={{
                        borderBottom: "1px dotted black",
                        margin: "15px",
                        padding: "15px",
                      }}
                    >
                      {error?.rcstemplate && <span style={{ color: "red" }}>{error?.rcstemplate}</span>}
                      <Col sm="1" className="mb-2 ">
                        <Label>RCS</Label>
                      </Col>


                      {channel?.rcsTemp?.map((rcsitem, index) => {
                        return (
                          <>
                            <Row
                              style={{
                                background: "rgb(243, 243, 243)",
                                margin: "5px",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Id"
                                    name="rcstemplate"
                                    type="text"
                                    value={rcsitem.rcstemplate}
                                    onChange={(e) =>
                                      templateHandle(e, "rcs", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="rcsctgry"

                                  value={rcsitem?.rcsctgry}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "rcsctgry",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "rcs", index)
                                  }}
                                  options={category}
                                  placeholder="Select Calegory"
                                />
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Type"
                                    name="rcsname"
                                    type="text"
                                    value={rcsitem.rcsname}
                                    onChange={(e) =>
                                      templateHandle(e, "rcs", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Type here"
                                    name="rcscontent"
                                    type="textarea"
                                    maxLength={5000}
                                    value={rcsitem.rcscontent}
                                    onChange={(e) =>
                                      templateHandle(e, "rcs", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              {rcsitem?.rcssenderArr?.map((senderitem, si) => {
                                return (
                                  <>
                                    <Col sm="3" className="mb-2 ">
                                      <FormGroup>
                                        <Input
                                          placeholder="Sender Id"
                                          type="text"
                                          name="rcssenderId"
                                          value={senderitem.rcssenderId}
                                          onChange={(e) =>
                                            senderHandle(e, index, si, "rcs")
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    {si == 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            addSenderIdRow("rcs", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-add"></i>
                                        </Button>
                                      </Col>
                                    )}
                                    {si > 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            removeSenderIdRow("rcs", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-delete"></i>
                                        </Button>
                                      </Col>
                                    )}
                                  </>
                                );
                              })}

                              {index == 0 ? (
                                <Col md="2" sm="12">
                                  {
                                    !props?.location?.state?.id &&
                                    <Button
                                      className="btn btn-icon btn-round btn-success"
                                      onClick={() => addTemplateRow("rcs")}
                                    >
                                      <i class="tim-icons icon-simple-add"></i>
                                    </Button>
                                  }
                                </Col>
                              ) : (
                                <Col md="2" sm="12">
                                  <Button
                                    className="btn btn-icon btn-round btn-danger "
                                    onClick={() =>
                                      removeTemplateRow("rcs", index)
                                    }
                                  >
                                    <i class="tim-icons icon-simple-delete"></i>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </>
                        );
                      })}
                    </Row>
                  )}
                  {channel.emailChkd === 1 && (
                    <Row
                      style={{
                        borderBottom: "1px dotted black",
                        margin: "15px",
                        padding: "15px",
                      }}
                    >
                      {error?.emailtemplate && <span style={{ color: "red" }}>{error?.emailtemplate}</span>}
                      <Col sm="1" className="mb-2 ">
                        <Label>
                          <span className="form-check-sign" />
                          Email
                        </Label>
                      </Col>


                      {channel?.emailTemp?.map((emailtem, index) => {
                        return (
                          <>
                            <Row
                              style={{
                                background: "rgb(243, 243, 243)",
                                margin: "5px",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Template Id"
                                    name="emailtemplate"
                                    type="text"
                                    value={emailtem.emailtemplate}
                                    onChange={(e) =>
                                      templateHandle(e, "email", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="emailctgry"

                                  value={emailtem?.emailctgry}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "emailctgry",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "email", index)
                                  }}
                                  options={category}
                                  placeholder="Select Calegory"
                                />
                              </Col>
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="Type here"
                                    name="emailcontent"
                                    type="textarea"
                                    maxLength={5000}
                                    value={emailtem.emailcontent}
                                    onChange={(e) =>
                                      templateHandle(e, "email", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              {emailtem?.emailsenderArr?.map(
                                (senderitem, si) => {
                                  return (
                                    <>
                                      <Col sm="3" className="mb-2 ">
                                        <FormGroup>
                                          <Input
                                            placeholder="Sender Id"
                                            type="text"
                                            name="emailsenderId"
                                            value={senderitem.emailsenderId}
                                            onChange={(e) =>
                                              senderHandle(
                                                e,
                                                index,
                                                si,
                                                "email"
                                              )
                                            }
                                          />
                                        </FormGroup>
                                      </Col>

                                      {si == 0 && (
                                        <Col md="2" sm="12">
                                          <Button
                                            onClick={() =>
                                              addSenderIdRow("email", index, si)
                                            }
                                          >
                                            <i class="tim-icons icon-simple-add"></i>
                                          </Button>
                                        </Col>
                                      )}
                                      {si > 0 && (
                                        <Col md="2" sm="12">
                                          <Button
                                            onClick={() =>
                                              removeSenderIdRow(
                                                "email",
                                                index,
                                                si
                                              )
                                            }
                                          >
                                            <i class="tim-icons icon-simple-delete"></i>
                                          </Button>
                                        </Col>
                                      )}
                                    </>
                                  );
                                }
                              )}

                              {index == 0 ? (
                                <Col md="2" sm="12">
                                  {
                                    !props?.location?.state?.id &&
                                    <Button
                                      className="btn btn-icon btn-round btn-success"
                                      onClick={() => addTemplateRow("email")}
                                    >
                                      <i class="tim-icons icon-simple-add"></i>
                                    </Button>
                                  }
                                </Col>
                              ) : (
                                <Col md="2" sm="12">
                                  <Button
                                    className="btn btn-icon btn-round btn-danger "
                                    onClick={() =>
                                      removeTemplateRow("email", index)
                                    }
                                  >
                                    <i class="tim-icons icon-simple-delete"></i>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </>
                        );
                      })}


                    </Row>
                  )}
                  {channel.ivrChkd === 1 && (
                    <Row
                      style={{
                        borderBottom: "1px dotted black",
                        margin: "15px",
                        padding: "15px",
                      }}
                    >
                      {error?.ivrtemplate && <span style={{ color: "red" }}>{error?.ivrtemplate}</span>}
                      <Col sm="1" className="mb-2 ">
                        <Label>Ivr</Label>
                      </Col>

                      {channel?.ivrTemp?.map((ivritem, index) => {
                        return (
                          <>
                            <Row
                              style={{
                                background: "rgb(243, 243, 243)",
                                margin: "5px",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <Col sm="3" className="mb-2 ">
                                <FormGroup>
                                  <Input
                                    placeholder="CallFlow Name"
                                    name="ivrtemplate"
                                    type="text"
                                    value={ivritem.ivrtemplate}
                                    onChange={(e) =>
                                      templateHandle(e, "ivr", index)
                                    }
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="3" className="mb-2">
                                <Select
                                  className="react-select info"
                                  classNamePrefix="react-select"
                                  name="ivrctgry"

                                  value={ivritem?.ivrctgry}
                                  onChange={(value) => {
                                    let e = {
                                      target: {
                                        name: "ivrctgry",
                                        value: value
                                      }
                                    }
                                    templateHandle(e, "ivr", index)
                                  }}
                                  options={category}
                                  placeholder="Select Calegory"
                                />
                              </Col>
                              <Col sm="3" className="mb-2 ">

                                {/* <Input
                                    placeholder="Type here"
                                    name="ivrcontent"
                                    type="textarea"
                                    maxLength={5000}
                                    value={ivritem.ivrcontent}
                                    onChange={(e) =>
                                      templateHandle(e, "ivr", index)
                                    }
                                  /> */}
                                <Input
                                  type="file"

                                  id="file"
                                  accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                  onChange={(e) => {
                                    // setImg(e.target.files[0]);
                                    uploadImg(e.target.files[0], index);
                                  }}
                                />
                                {
                                  ivritem.ivrcontent && <Label>
                                    <a target="_blank" href={ivritem.ivrcontent}>
                                      Preview
                                    </a>
                                  </Label>
                                }

                              </Col>
                              {ivritem?.ivrsenderArr?.map((senderitem, si) => {
                                return (
                                  <>
                                    <Col sm="3" className="mb-2 ">
                                      <FormGroup>
                                        <Input
                                          placeholder="Sender Id"
                                          type="text"
                                          name="ivrsenderId"
                                          value={senderitem.ivrsenderId}
                                          onChange={(e) =>
                                            senderHandle(e, index, si, "ivr")
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    {si == 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            addSenderIdRow("ivr", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-add"></i>
                                        </Button>
                                      </Col>
                                    )}
                                    {si > 0 && (
                                      <Col md="2" sm="12">
                                        <Button
                                          onClick={() =>
                                            removeSenderIdRow("ivr", index, si)
                                          }
                                        >
                                          <i class="tim-icons icon-simple-delete"></i>
                                        </Button>
                                      </Col>
                                    )}
                                  </>
                                );
                              })}

                              {index == 0 ? (
                                <Col md="2" sm="12">
                                  {
                                    !props?.location?.state?.id &&
                                    <Button
                                      className="btn btn-icon btn-round btn-success"
                                      onClick={() => addTemplateRow("ivr")}
                                    >
                                      <i class="tim-icons icon-simple-add"></i>
                                    </Button>
                                  }
                                </Col>
                              ) : (
                                <Col md="2" sm="12">
                                  <Button
                                    className="btn btn-icon btn-round btn-danger "
                                    onClick={() =>
                                      removeTemplateRow("ivr", index)
                                    }
                                  >
                                    <i class="tim-icons icon-simple-delete"></i>
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </>
                        );
                      })}

                    </Row>
                  )}

                </Col>
                <Row>
                  <Col sm="4">
                    <Button type="submit" className="btn btn-icon btn-primary">
                      <i
                        className="tim-icons icon-double-right"
                        onClick={() => submitChannel()}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              </Row>
            </CardBody>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default CreateChannel;


